"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBreakpoint = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _CarrierLogo = _interopRequireDefault(require("../CarrierLogo"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _constant = require("../constant");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant2 = require("./constant");
var _Carrier = _interopRequireDefault(require("./Carrier.proptypes"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledCarrierContainer = _styledComponents.default.div.withConfig({
  displayName: "Carrier__StyledCarrierContainer",
  componentId: "sc-haklbz-0"
})(["padding:", ";background:", ";border-radius:", ";margin-left:", ";display:block;&:before{content:attr(data-time);left:-60px;position:absolute;display:flex;font-family:", ";font-size:", ";color:", ";width:50px;word-break:break-word;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.XSmall;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.greyLighter;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius.normal;
}, function (_ref4) {
  var theme = _ref4.theme,
    hasDesignator = _ref4.hasDesignator;
  return hasDesignator && theme.space.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return (// eslint-disable-next-line max-len
    "".concat(theme.fontFamily.default, ", 'Nunito Sans', -apple-system, '.SFNSText-Regular', 'San Francisco', BlinkMacSystemFont, 'Segoe UI',\n    'Helvetica Neue', Helvetica, Arial, sans-serif")
  );
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.XSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyDark;
});
var StyledCarrierItemContainer = _styledComponents.default.div.withConfig({
  displayName: "Carrier__StyledCarrierItemContainer",
  componentId: "sc-haklbz-1"
})(["display:flex;align-items:center;"]);
var StyledCarrierCabinContainer = _styledComponents.default.div.withConfig({
  displayName: "Carrier__StyledCarrierCabinContainer",
  componentId: "sc-haklbz-2"
})(["display:flex;align-items:center;padding-left:", ";"], function (_ref8) {
  var theme = _ref8.theme,
    paddingLeft = _ref8.paddingLeft;
  return theme.space[paddingLeft];
});
var StyledOperatorContainer = _styledComponents.default.div.withConfig({
  displayName: "Carrier__StyledOperatorContainer",
  componentId: "sc-haklbz-3"
})(["display:flex;padding-left:30px;"]);
var setBreakpoint = function setBreakpoint(bp) {
  if (bp <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10)) {
    return true;
  }
  return false;
};
exports.setBreakpoint = setBreakpoint;
var convertSecToHr = function convertSecToHr(seconds) {
  var hrs = seconds / 3600;
  var hour = Math.floor(hrs);
  var minute = Math.round((hrs - hour) * 60);
  return {
    hour: hour,
    minute: minute
  };
};
var checkOperatingFlightNumber = function checkOperatingFlightNumber(carrier) {
  if (carrier.operatingFlightNumber !== (null || undefined)) {
    return "".concat(carrier.operatingCarrierCode, " ").concat(carrier.operatingFlightNumber);
  }
  return '';
};
var Carrier = function Carrier(_ref9) {
  var theme = _ref9.theme,
    accessible = _ref9.accessible,
    customProperties = _ref9.customProperties,
    designator = _ref9.designator,
    carrier = _ref9.carrier,
    carrierLogoSize = _ref9.carrierLogoSize,
    translation = _ref9.translation,
    duration = _ref9.duration,
    isMobile = _ref9.isMobile,
    isBusFerry = _ref9.isBusFerry,
    busFerryLabel = _ref9.busFerryLabel;
  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 1300;
  };
  var _React$useState = _react.default.useState(innerWidth),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    windowWidth = _React$useState2[0],
    setWindowWidth = _React$useState2[1];
  /* istanbul ignore next */
  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }
    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);
  var hasDesignator = designator && !!Object.keys(designator).length;
  var _ref10 = hasDesignator ? convertSecToHr(duration) : {},
    _ref10$hour = _ref10.hour,
    hour = _ref10$hour === void 0 ? 0 : _ref10$hour,
    _ref10$minute = _ref10.minute,
    minute = _ref10$minute === void 0 ? 0 : _ref10$minute;
  var opertingCarrierDiffToMarketingCarrier = carrier.operatingCarrierCode && carrier.operatingFlightNumber && carrier.operatingCarrierCode !== carrier.marketingCarrierCode;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledCarrierContainer, (0, _extends2.default)({
    hasDesignator: hasDesignator
  }, hasDesignator && {
    'data-time': "".concat(_utilities.default.constructDuration(hour, minute, language))
  }, {
    tabIndex: !accessible ? '-1' : '0'
  }, customProperties, {
    mobile: isMobile || setBreakpoint(windowWidth)
  }), /*#__PURE__*/_react.default.createElement(StyledCarrierItemContainer, null, isBusFerry ? /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant2.DISPLAYS.block,
    theme: theme,
    type: "sub",
    color: _constant2.COLORS.greyDark,
    bold: true,
    customProperties: {
      style: {
        marginLeft: 10
      }
    }
  }, busFerryLabel) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CarrierLogo.default, {
    accessible: accessible,
    carriers: [carrier],
    size: carrierLogoSize,
    placeHolderBackground: "greyLighter",
    theme: theme
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant2.DISPLAYS.block,
    theme: theme,
    type: "sub",
    color: _constant2.COLORS.greyDark,
    bold: true,
    customProperties: {
      style: {
        marginLeft: 10
      }
    }
  }, carrier.marketingCarrierName, ", ", carrier.marketingCarrierCode, " ", carrier.marketingFlightNumber))), /*#__PURE__*/_react.default.createElement("div", null, opertingCarrierDiffToMarketingCarrier && /*#__PURE__*/_react.default.createElement(StyledOperatorContainer, {
    mobile: isMobile || setBreakpoint(windowWidth)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    accessible: accessible,
    icon: _constant2.SUB_ICON,
    theme: theme,
    fontsize: "normal",
    color: _constant2.COLORS.greyDark
  }), /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant2.DISPLAYS.inlineFlex,
    theme: theme,
    type: _constant2.CARRIER_TEXT.SUB,
    color: _constant2.COLORS.greyDark
  }, language.operated, " ", carrier.operatingCarrierName, " ", checkOperatingFlightNumber(carrier))), (carrier === null || carrier === void 0 ? void 0 : carrier.cabinClass) && /*#__PURE__*/_react.default.createElement(StyledCarrierCabinContainer, {
    paddingLeft: _constant2.CARRIER_TEXT.PADDING
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    accessible: accessible,
    display: _constant2.DISPLAYS.inlineFlex,
    theme: theme,
    type: _constant2.CARRIER_TEXT.SUB,
    color: _constant2.COLORS.greyDark
  }, language[_constant2.CABIN_CLASS[carrier.cabinClass]])))));
};
Carrier.propTypes = _Carrier.default.PropTypes;
Carrier.defaultProps = _Carrier.default.DefaultProps;
var _default = Carrier;
exports.default = _default;